import { getData } from '../BlockText';
import moment from 'moment';

type SortMethod = (a: any, b: any, desc: any) => number;

interface Comparator {
  match: (s: string) => boolean;
  sortMethod: (a: any, b: any) => number;
}

export const numberComparator: Comparator = {
  match: s => /^\d+$/.test(s),
  sortMethod: (a, b) => Number(a) - Number(b),
};

export const formattedNumberComparator: Comparator = {
  match: s => /^\d+((\,\d{3})+)?$/.test(s),
  sortMethod: (a, b) => Number(a.split(',').join('')) - Number(b.split(',').join('')),
};

export const dateComparator: Comparator = {
  match: s => /^\d{1,2}\s\w{3,10},\s\d\d\d\d$/.test(s),
  sortMethod: (a, b) => {
    const dateA = moment(a);

    const dateB = moment(b);

    if (dateA.isValid() && dateB.isValid()) {
      return dateA.diff(dateB);
    } else {
      return a.localeCompare(b);
    }
  },
};

export const percentNumberComparator: Comparator = {
  // We allow suffix string at the end of the percent numbers
  // Example: 60%, 65%(Low), 12%abcd
  // https://jira.worldquant.com/browse/BRAINTECH-1448
  match: s => /^\d+\%/.test(s),
  sortMethod: (a, b) => parseInt(a, 10) - parseInt(b, 10),
};

const specialComparators: Comparator[] = [numberComparator, formattedNumberComparator, percentNumberComparator, dateComparator];

const stickToBottomList = ['—'];

export const sortMethod: SortMethod = (a, b, desc) => {
  const dataA = getData(a);
  const dataB = getData(b);

  if (stickToBottomList.includes(dataA)) {
    return desc ? -1 : 1;
  }

  if (stickToBottomList.includes(dataB)) {
    return desc ? 1 : -1;
  }

  // Looking for special comparision
  for (const comparator of specialComparators) {
    if (comparator.match(dataA) && comparator.match(dataB)) {
      return comparator.sortMethod(dataA, dataB);
    }
  }

  // Fallback to string comparison
  return dataA === dataB ? 0 : dataA > dataB ? 1 : -1;
};
